import EmailItem from "./EmailItem";
import EmailDraftItem from "./EmailDraftItem";

export default class EmailConversation {
    constructor(id, firstEmailItem, isKeyDecision = false) {
        this.id = id;
        this.items = [firstEmailItem];

        // Player should only be able to make key decisions through the key decision menu
        this._isKeyDecision = isKeyDecision;
    }

    getItems() {
        return this.items;
    }

    addItem(item, isKeyDecision = false) {
        this.items.add(item);

        this._isKeyDecision = isKeyDecision;
    }

    markRead(value) {
        for (var i = 0; i < this.items.length; i++) {
            this.items[i].isRead = value;
        }
    }

    hasUnreadItems() {
        var unreadItems = this.items.filter(i => !i.isRead);
        return unreadItems.length > 0;
    }

    requiresReply() {
        return this.items.some(i => i instanceof EmailDraftItem && !i.isSent);
    }

    isInbox() {
        return this.getItems().some(i => i instanceof EmailItem && !(i instanceof EmailDraftItem));
    }

    isOutbox() {
        return this.getItems().some(i => i instanceof EmailDraftItem && i.isSent);
    }

    get isKeyDecision() {
        return this._isKeyDecision;
    }
}